<div class="topbar container">
  <h1 class="topbar__logo">
    <a [routerLink]="'/'">
      <img src="/assets/gfx/fitscan-logo.svg" alt=" Fitscan">
    </a>
  </h1>
</div>
  